import React            from 'react';
import UiKit            from "../../../uikit";

class Spinner extends React.Component {
    constructor(props) {
        super(props);
        this.state = { };
    }

    render(){
        return(
            <div className={ `simprakit-dropdown-wrapper-spinner` }>
                <UiKit.Icon icon="line-spinner" />
            </div>
        )
    }
}

export default Spinner;